export class OtpVerificationError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'OtpVerificationError';
    }
}
